import { isOperator, isValidOperator, makeOperator } from './Operator';
import isString from 'transmute/isString';
export default makeOperator({
  name: 'PropertyNameAndValue',
  values: [{
    name: 'referencedObjectTypeId',
    isValid: isString
  }, {
    name: 'propertyName',
    defaultValue: '',
    isValid: isString
  }, {
    name: 'propertyValue',
    defaultValue: undefined,
    isValid: thing => Boolean(thing && isOperator(thing) && isValidOperator(thing))
  }]
});